import { Loader } from 'lucide-react';

export function PageLoader({ label }: { label: string }) {
    return (
        <div className="flex flex-col justify-center items-center h-64">
            <Loader className="w-12 h-12 animate-spin text-brand mb-4" />
            <p className="text-coolslate">{label}</p>
        </div>
    );
}
